import type { RadioSession } from "@src/types";
import { useMutation } from "@tanstack/react-query";

import { registerRadioSession } from "@src/services/api/session";

export function useRegisterRadioSessionMutation(method: "POST" | "DELETE") {
  return useMutation<RadioSession, Error, { idRadio: string; cnpj?: string }>({
    mutationKey: ["register_radio_session", method],
    mutationFn: async ({ idRadio, cnpj }) => {
      registerRadioSession.clear();
      return registerRadioSession(method, idRadio, cnpj);
    },
    onError: console.log,
  });
}
